import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useQuery, gql} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getCompanyDetails($locale: String!){
 companyDetailsCollection(limit: 1, locale: $locale){
    items{
      currencySelectionCollection {
        items {
          name
          title
          locale
        }
      }
    }
  }
}
`;

export const useCurrencyCollection = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, { variables: { locale: localeUppercase}, errorPolicy: "all", fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first"});
    const currencySelectionCollection = data?.companyDetailsCollection.items[0].currencySelectionCollection.items;

    if (error?.message) {
        logger(error?.message, "error", "useCurrencyCollection", error?.stack);
    }

    return {
        currencySelectionCollection,
        loading,
        error
    };
};
